export default __webpack_public_path__ + "static/media/inst.a26279e7.svg";